<template>
  <app-header :theme="theme">
    <template #brand>
      <brand-logo to="/home" img-style="max-height: 36px; max-width: 250px" />
    </template>
    <template #actions>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasNavbar"
        aria-controls="offcanvasNavbar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
    </template>
    <template #drawer>
      <off-canvas-navbar @changeTheme="theme = $event">
        <template #nav-panel>
          <nav-links :links="navMenu">
            <li class="nav-item">
              <a
                class="nav-link rounded position-relative"
                aria-current="page"
                data-bs-dismiss="offcanvas"
                @click="$router.push({ name: 'Settings' })"
                :class="$route.name == 'Settings' ? 'active disabled' : ''"
                style="cursor: pointer"
              >
                {{ $t("nav.settings") }}
              </a>
            </li>
            <li class="nav-item d-flex align-items-center">
              <div class="d-none d-md-block">
                <data-bs-theme @changeTheme="theme = $event"></data-bs-theme>
              </div>
            </li>
          </nav-links>
        </template>
      </off-canvas-navbar>
    </template>
  </app-header>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

import AppHeader from "./app-header.vue";
import BrandLogo from "./brand-logo.vue";
import NavLinks from "@/components/app/nav-links.vue";
import DataBsTheme from "@/components/app/data-bs-theme.vue";
import OffCanvasNavbar from "@/components/app/off-canvas-navbar.vue";
import nav, { INav } from "@/config/nav/nav.config";

@Options({
  components: { AppHeader, BrandLogo, NavLinks, DataBsTheme, OffCanvasNavbar },
})
class ClassicalHeader extends Vue {
  theme = localStorage.getItem("data-bs-theme");
  navMenu: Array<INav> = nav;
}
export default ClassicalHeader;
</script>
<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";
</style>
